module.exports = __webpack_public_path__ + "img/b5-افقی.81f8ab02.jpg";